import {AddressBookResponseCode} from '@web/core/constants'

export {
    AddressBookResponseCode,
    AddressBookRequestFailMessage,
    DefaultAddressBookRequestFailMessage,
} from '@web/core/constants'

export const ValidateSelectedZipCodeFailType = {
    LOT_NUMBER_ADDRESS_ZIPCODE: 'LOT_NUMBER_ADDRESS_ZIPCODE',
    LOT_NUMBER_ADDRESS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_DELIVERY:
        'LOT_NUMBER_ADDRESS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_DELIVERY',
    ROAD_NAME_ADDRESS_ZIPCODE_VALIDATION_API_FAIL: 'ROAD_NAME_ADDRESS_ZIPCODE_VALIDATION_API_FAIL',
} as const

type ValidateSelectedZipCodeFailTypeValue = Constant<typeof ValidateSelectedZipCodeFailType>

export const ValidateSelectedZipCodeFailMessage: Record<ValidateSelectedZipCodeFailTypeValue, string> = {
    [ValidateSelectedZipCodeFailType.LOT_NUMBER_ADDRESS_ZIPCODE]:
        '우편번호 6자리 배송지는 사용이 불가합니다. 정확한 배송을 위해 우편번호 5자리 배송지로 수정해주세요.',
    [ValidateSelectedZipCodeFailType.LOT_NUMBER_ADDRESS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_DELIVERY]:
        'N배송 상품을 주문하시려면 도로명 주소로 입력해 주셔야 합니다. \n정확한 주소가 입력되지 않은 경우 도착보장일은 ‘서울시 강남구 역삼동’ 기준으로 노출됩니다.',
    [ValidateSelectedZipCodeFailType.ROAD_NAME_ADDRESS_ZIPCODE_VALIDATION_API_FAIL]: '',
}

export const AddressBookEntranceRequestFailMessage: Record<string, string> = {
    [AddressBookResponseCode.NOT_EXIST]: '출입방법 저장에 실패했습니다. 배송지를 다시 선택해주시거나 재등록해주세요.',
}
